// extracted by mini-css-extract-plugin
export default {"drawer":"MenuDrawer_drawer__4dVg-","filler":"MenuDrawer_filler__gFw4z"};